import { render, staticRenderFns } from "./VendorCategoriesList.vue?vue&type=template&id=6d64264c"
import script from "./VendorCategoriesList.vue?vue&type=script&lang=js"
export * from "./VendorCategoriesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports